import { getApiActionTypes } from '../../shared/store/storeHelpers';

export const fetchFlowThroughK1DetailsTypes = getApiActionTypes('FETCH_FLOW_THROUGH_K1_DETAILS');
export const fetchPartnersTypes = getApiActionTypes('FETCH_PARTNERS');
export const updateFlowThroughK1DetailsTypes = getApiActionTypes('UPDATE_FLOW_THROUGH_K1_DETAILS');
export const SELECT_PARTNER_ID = 'SELECT_PARTNER_ID';
